import { REDUX_ACTIONS, GAME_ID, SCREENS } from '../../data/constants';

const initState = {
  isOnboarded: false,
  isRepeatOnboarding: false,
  hasSeenIntroduction: false,
};

const sessionReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
        isRepeatOnboarding: false,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN: {
      if (payload === SCREENS.PROGRESS) {
        return {
          ...state,
          isRepeatOnboarding: false,
        };
      }
      return state;
    }

    case REDUX_ACTIONS.COMPLETE_INTRODUCTION:
      return {
        ...state,
        hasSeenIntroduction: true,
      };

    case REDUX_ACTIONS.REPEAT_ONBOARDING:
      return {
        ...state,
        isRepeatOnboarding: true,
      };

    default:
      return state;
  }
};

export default sessionReducer;
